import { createReducer } from 'modules/util'
import ActionType from '../constants/actionTypes'

export const initialState = {
  email: '',
  courseCode: ''
}

const handlers = {
  [ActionType.UPDATE_FORM_VALUES]: updateForm
}

export default createReducer(initialState, handlers)

function updateForm(state, { payload: { form } }) {
  return { ...state, ...form }
}



// WEBPACK FOOTER //
// ./client/modules/user/reducers/form.js